import React, { useState } from 'react';
import WmsSidebar from '../../components/WmsSidebar';
import WmsTopbar from '../../components/wms_topbar';
import { ArrowDownToLine, ArrowUpToLine, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const WmsOrdenes = () => {
  const [activeItem, setActiveItem] = useState('ordenes');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="flex">
      {/* Sidebar drawer solo en móvil */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
      <div
        className={`fixed z-50 inset-y-0 left-0 transition-transform duration-300 md:hidden ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
        style={{ width: '256px', minHeight: '100vh' }}
      >
        <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      </div>
      {/* Sidebar estático solo en desktop, en el flujo normal */}
      <div className="hidden md:flex">
        <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      </div>
      <div className="flex-1 bg-gray-100 min-h-screen md:p-6">
        <WmsTopbar rightContent={
          <button
            className="md:hidden p-2 ml-2"
            onClick={() => setSidebarOpen(true)}
            aria-label="Abrir menú"
            style={{ background: 'transparent', border: 'none', boxShadow: 'none' }}
          >
            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-menu"><line x1="3" y1="12" x2="25" y2="12"/><line x1="3" y1="6" x2="25" y2="6"/><line x1="3" y1="18" x2="25" y2="18"/></svg>
          </button>
        } />
        <div className="w-full px-2 sm:px-6 flex flex-col items-center">
          <h1 className="text-xl sm:text-2xl font-bold mb-2 text-center mt-4">Órdenes de Salida (Picking y Packing)</h1>
          <p className="mb-6 text-center text-gray-700 text-base sm:text-lg">Creación y gestión de órdenes de salida, picking, packing y despacho.</p>
          <div className="flex gap-4 sm:gap-8 mt-4 sm:mt-8 justify-center w-full flex-wrap">
            <button
              className="flex flex-col items-center justify-center bg-blue-700 hover:bg-blue-800 text-white rounded-xl shadow-lg w-28 h-28 sm:w-32 sm:h-32 transition-all focus:outline-none focus:ring-2 focus:ring-blue-400 mb-4"
              onClick={() => navigate('/wms/ordenes/entrada')}
            >
              <ArrowDownToLine className="w-10 h-10 sm:w-12 sm:h-12 mb-2" />
              <span className="font-semibold text-base sm:text-lg">Orden de Entrada</span>
            </button>
            <button
              className="flex flex-col items-center justify-center bg-blue-700 hover:bg-blue-800 text-white rounded-xl shadow-lg w-28 h-28 sm:w-32 sm:h-32 transition-all focus:outline-none focus:ring-2 focus:ring-blue-400 mb-4"
              onClick={() => navigate('/wms/ordenes/salida')}
            >
              <ArrowUpToLine className="w-10 h-10 sm:w-12 sm:h-12 mb-2" />
              <span className="font-semibold text-base sm:text-lg">Orden de Salida</span>
            </button>
            <button
              className="flex flex-col items-center justify-center bg-blue-700 hover:bg-blue-800 text-white rounded-xl shadow-lg w-28 h-28 sm:w-32 sm:h-32 transition-all focus:outline-none focus:ring-2 focus:ring-blue-400 mb-4"
              onClick={() => navigate('/wms/ordenes/consulta')}
            >
              <Eye className="w-10 h-10 sm:w-12 sm:h-12 mb-2" />
              <span className="font-semibold text-base sm:text-lg">Consultar Órdenes</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WmsOrdenes;
